/**
 * The Environment context
 */
import * as React from "react"
import { Environment, defaultEnvironment } from "./Environment"

const EnvironmentContext = React.createContext<Environment>(defaultEnvironment)

export default EnvironmentContext
